import React, { FC, memo, useMemo } from 'react';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { getWarehouseInfo } from 'pages/BookingPage';
import { useGetSizeCodesForBookingQuery } from 'entities/SizeCode';
import { useGetRentOptionsQuery } from 'entities/RentOption';
import { ModernBoxSizeFilter } from 'features/ModernBoxSizeFilter';
import { ModernSizeCodeSelect } from 'features/ModernSizeCodeSelect';
import { Box } from 'entities/Box';

interface ModernSelectBoxSizeContentProps {
  selectedBoxId: string | undefined;
  onSelectBox: (box: Box, sizeCodeId: string) => void;
  onCompleteStep: (box: Box, sizeCodeId: string) => void;
}

export const ModernSelectBoxSizeContent: FC<ModernSelectBoxSizeContentProps> = memo((props) => {
  const { selectedBoxId, onSelectBox, onCompleteStep } = props;

  const warehouseInfo = useAppSelector(getWarehouseInfo);
  const selectedWarehouseId = warehouseInfo?.warehouseId;

  const { data: sizeCodes } = useGetSizeCodesForBookingQuery({ warehouseId: selectedWarehouseId }, { skip: !selectedWarehouseId });

  const { data: rentOptions } = useGetRentOptionsQuery({ warehouseId: selectedWarehouseId }, { skip: !selectedWarehouseId });

  const sortedSizeCodes = useMemo(() => {
    if (!sizeCodes) return undefined;
    return [...sizeCodes].sort((a, b) => a.square - b.square);
  }, [sizeCodes]);

  return (
    <div className="space-y-6">
      <ModernBoxSizeFilter sizeCodes={sortedSizeCodes} />

      <ModernSizeCodeSelect
        sizeCodes={sortedSizeCodes}
        rentOptions={rentOptions}
        selectedBoxId={selectedBoxId}
        onSelectBox={onSelectBox}
        onBookBox={onCompleteStep}
      />
    </div>
  );
});
